<template>
    <b-container fluid>
        <header-buttons
                :buttons="headerButtons"
                @onSaveUser="saveUser"
                @onPasswordUpdate="passwordUpdate"
        ></header-buttons>
        <b-row>
            <b-col cols="12">
                <society-form
                        :user="society">
                </society-form>
            </b-col>
        </b-row>
        <hr>
        <b-row class="justify-content-center">
            <b-col cols="12" md="4">
                <h3 class="text-primary text-uppercase">Centro messaggi</h3>
                <hr>
                <div class="mb-3">
                    <div v-if="notices.length">
                        <div class="mb-3"
                             v-for="(notice, index) in notices" v-bind:key="index">
                            <b-alert :variant="notice.level" show>
                                <h4 class="alert-heading">{{notice.title}}</h4>
                                <p><span v-html="notice.text"></span></p>
                            </b-alert>
                        </div>
                    </div>
                    <div v-else>
                        <div class="mb-3">
                            <b-alert variant="success" show>
                                Non sono disponibili messaggi per te
                            </b-alert>
                        </div>
                    </div>
                </div>
            </b-col>
            <b-col cols="12" md="4">
                <h3 class="text-primary text-uppercase">Partite disponibili</h3>
                <hr>
                <div v-if="availableMatches.length">
                    <div class="mb-3"
                         v-for="(match, index) in availableMatches" v-bind:key="index">
                        <society-dash-match-container :match="match"></society-dash-match-container>
                    </div>
                </div>
                <div v-else>
                    <div class="mb-3">
                        <b-alert variant="warning" show>
                            Non sono disponibili partite al momento
                        </b-alert>
                    </div>
                </div>
            </b-col>
            <b-col cols="12" md="4">
                <h3 class="text-primary text-uppercase">Richieste in corso</h3>
                <hr>
                <div v-if="pendingRequests.length">
                    <div class="mb-3"
                         v-for="(request, index) in pendingRequests" v-bind:key="index">
                        <society-dash-request-container :matchRequest="request" @onClick="openRequestDetail"></society-dash-request-container>
                    </div>
                </div>
                <div v-else>
                    <div class="mb-3">
                        <b-alert variant="warning" show>
                            Non ci sono richieste in corso
                        </b-alert>
                    </div>
                </div>
            </b-col>
        </b-row>
        <modal-update-password
                :showModal="showModalUpdatePassword"
                @updateShowModal="(value) => { showModalUpdatePassword = value }"></modal-update-password>
    </b-container>
</template>

<script>

    import HeaderButtons from "../../../components/headers-buttons/HeaderButtons";
    import {mapGetters, mapActions} from 'vuex';
    import User from "@/models/User";
    import CONST from "@/const";
    import SocietyForm from "../components/SocietyForm";
    import SocietyDashMatchContainer from "../components/SocietyDashMatchContainer/SocietyDashMatchContainer";
    import SocietyDashRequestContainer from "../components/SocietyDashRequestContainer/SocietyDashRequestContainer";
    import ModalUpdatePassword from "../../../components/modal-update-password/ModalUpdatePassword";

    export default {
        name: "SocietyDashView",
        components: {
            ModalUpdatePassword,
            SocietyDashRequestContainer, SocietyDashMatchContainer, SocietyForm, HeaderButtons},
        data() {
            return {
                headerButtons: [
                    {
                        label: 'Salva Profilo',
                        confirm: true,
                        onClick: 'onSaveUser',
                    },
                    {
                        label: 'Cambia Password',
                        onClick: 'onPasswordUpdate',
                    }
                ],
                society: Object.assign({}, User),
                availableMatches: [],
                pendingRequests: [],
                notices: [],
                showModalUpdatePassword: false
            }
        },
        computed: {
            ...mapGetters([
                'currentUser'
            ]),
        },
        mounted() {

            this.$root.$on('bv::modal::hide', () => {
                this.showModalUpdatePassword = false;
            });

            this.society = Object.assign({}, this.currentUser);

            this.societyDashAvailableMatches()
                .then((data) => {
                    this.availableMatches = data;
                }).catch(() => {
                this.$bvToast.toast('Problemi nel caricamento dei match disponibili', {
                    title: 'Alert',
                    variant: 'warning'
                });
            });

            this.societyMatchesGetRequestsByStatus([
                CONST.REQUEST_STATUSES.pending.name,
                CONST.REQUEST_STATUSES.paid.name,
                CONST.REQUEST_STATUSES.warning.name,
            ])
                .then((data) => {
                    this.pendingRequests = data;
                }).catch(() => {
                this.$bvToast.toast('Problemi nel caricamento delle richieste in attesa', {
                    title: 'Alert',
                    variant: 'warning'
                });
            });

            this.societyDashGetNotices()
                .then((data) => {
                    this.notices = data;
                }).catch(() => {
                this.$bvToast.toast('Problemi nel caricamento delle notifiche', {
                    title: 'Alert',
                    variant: 'warning'
                });
            });

            if (this.currentUser.tempPassword) {
                this.showModalUpdatePassword = true;
            }
        },
        methods: {

            ...mapActions({
                societyDashUpdateUser: 'societyDashUpdateUser',
                societyDashAvailableMatches: 'societyDashAvailableMatches',
                societyMatchesGetRequestsByStatus: 'societyMatchesGetRequestsByStatus',
                societyDashGetNotices: 'societyDashGetNotices',
                societyMatchesShowRequest: 'societyMatchesShowRequest',
            }),

            openRequestDetail(request) {

                this.societyMatchesShowRequest(request)
                    .then((data) => {
                        this.$router.push({name: 'society.matches.request', params: {id: data.id}})
                    }).catch(() => {
                    this.$bvToast.toast('Problemi nel caricamento della richeista', {
                        title: 'Alert',
                        variant: 'warning'
                    });
                })

            },

            saveUser: function () {
                this.societyDashUpdateUser(this.society)
                    .then(() => {
                        this.$bvToast.toast('Dati society salvati correttemente', {
                            title: 'Success',
                            variant: 'success'
                        });
                    })
                    .catch(() => {
                        this.$bvToast.toast('Problemi nel salvataggio del society', {
                            title: 'Alert',
                            variant: 'warning'
                        });
                    })
            },

            passwordUpdate: function() {
                this.showModalUpdatePassword = true;
            }
        }
    }
</script>

<style scoped>

</style>
